function getHead (vm) {
	//自定义head组件
	const { head } = vm.$options;

	if (head) {
		return typeof head === 'function' ?
			head.call(vm) :
			head;
	}
}
 
const serverHeadMixin = {
  created () {
    const head = getHead(this);
	if (head) {
		//将当前页面中自定义的title属性等赋值给context.title来改变标题
		if (head.title) this.$ssrContext.title = `${head.title}-全智能科技`;
		if (head.keywords) this.$ssrContext.keywords = head.keywords;
		if (head.description) this.$ssrContext.description = head.description;
	}
  }
};
 
// const clientHeadMixin = {
//   mounted () {
//     const head = getHead(this);
 
//     if (head) {
//       if (head.title) document.title = `${head.title}-全智能科技`;
//       if (head.keywords) document.querySelector('meta[name="keywords"]').setAttribute('content', head.keywords);
//       if (head.description) document.querySelector('meta[name="description"]').setAttribute('content', head.description);
//     }
//   }
// };
 
/**
 * vue 官网中的示例process.env.VUE_ENV你不设置它，它是未定义的。
 * 我们需要做到的是
 * 	1.当服务器渲染执行serverHeadMixin
 * 	2.当客户端渲染执行clientHeadMixin，由于我们没有使用clientHeadMixin，会导致客户端渲染时候
 * 		提示title未定义。
 */
// export default  document != undefined ?
// 	clientHeadMixin :
// 	serverHeadMixin;
	
// export default
// 	clientHeadMixin;
export default
	serverHeadMixin;
